module.exports = __webpack_public_path__ + "media/images/banner03-562d7ab97fc6e8933e4650516914ea84.webp";